import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false
}: CardProps) {
  return <div className={`bg-surface border border-border rounded-lg overflow-hidden transition-all hover:border-border/80 ${className}`} data-id="element-363">
      <div className={noPadding ? '' : 'p-6'} data-id="element-364">{children}</div>
    </div>;
}